import React, { useEffect, useState } from 'react'
import Form from '../../../../components/Form'
import CheckBox from '../../../../components/Form/Fields/CheckBox'
import Select from '../../../../components/Form/Fields/Select'
import FieldType from '../../../../components/Form/Fields/type'
import { Status, STATUS } from '../../../../models/Realty'

export interface FilterData {
  text?: string
  has_realties?: string
  realty_status?: string
  city?: string
  role?: string
  deleted?: boolean
}

const fields: FieldType<keyof FilterData>[] = [
  {
    name: 'text',
    data: {
      label: '',
    },
    html: {
      maxLength: 255,
      placeholder: 'Nome, CPF, ID do usuário',
    },
  },
  {
    name: 'has_realties',
    component: Select,
    data: {
      label: '',
      options: [{
        label: 'Tem imóvel?',
        value: '',
      }, {
        label: 'Sim',
        value: 'true',
      }, {
        label: 'Não',
        value: 'false',
      }],
    },
  },
  {
    name: 'city',
    data: {},
    html: { placeholder: 'Cidade' },
  },
  {
    name: 'realty_status',
    component: Select,
    data: {
      label: '',
      options: [
        {
          label: 'Situação do imóvel',
          value: '',
        },
        ...Object.keys(STATUS).map((key: string) => ({
          label: STATUS[key as Status],
          value: key,
        })),
      ],
    },
  },
  {
    name: 'deleted',
    component: CheckBox,
    data: {
      label: 'Excluído',
    },
    html: { type: 'checkbox', value: true },
  },
]

interface Props {
  filters?: string[]
  onChange: (data: FilterData) => void
  initialParams?: FilterData
}

const Filter: React.FC<Props> = ({ onChange, filters, initialParams = {} }) => {
  const [fieldsIn, setFieldsIn] = useState(fields)

  useEffect(() => {
    if (filters) {
      const fieldsFilter = fields.filter((item: any) => {
        return filters.find(x => x === item.name)
      })
      setFieldsIn(fieldsFilter)
    }
  }, [filters])

  return (
    <Form<FilterData>
      buttonLabel="Filtrar"
      fields={fieldsIn}
      initialValues={initialParams}
      onSubmit={data => {
        const keys = Object.keys(data) as (keyof FilterData)[]
        keys.map(k => (data[k] === '') && delete data[k])
        onChange(data)
      }}
      horizontal
      buttonProps={{
        backgroundColor: 'transparent',
        fontColor: 'darkBlue',
        borderColor: 'darkBlue',
      }}
    />
  )
}

export default Filter
